@let order = order$();
@let options = options$();

<div class="order-summary">
	@if (order && options?.showOrderDetails) {
		<g-order-summary-header
			[order]="order"
			[options]="{
				shouldShowOrderStatus: options?.showOrderStatus ?? false,
				isCheckoutV2: false,
			}"
		/>
	}
	<g-order-product-list
		[order]="order"
		[showCopyToBasket]="options?.showCopyToBasket ?? false"
		[showPrices]="options?.showPrices ?? false"
	/>
	@if (options?.showPrices) {
		<g-price-summary
			[isConfirmedOrder]="options?.isConfirmedOrder ?? false"
			[order]="order"
			[showPriceBreakdown]="true"
		/>
	}
	<g-address-summary [isConfirmedOrder]="options?.isConfirmedOrder ?? false" [order]="order" />
</div>

<div class="print hide-in-print">
	<button type="button" (click)="printReceipt()">
		<g-icon [icon]="icons.faPrint" fixedWidth />
		<span i18n="@@OrderSummaryPrintButton">Print receipt</span>
	</button>
</div>
